import { PathSegmentResolver } from '../../utils/use-path';

export const resolveContactPath: PathSegmentResolver = ({ defaultLink }) => {
  return {
    title: 'Kontakt',
    isPageTitle: true,
    link: defaultLink,
  };
};
